"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ramda = require("ramda");

var _getSession = _interopRequireDefault(require("./getSession"));

var _setSession = _interopRequireDefault(require("./setSession"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var updateSession = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var baseUrl, sessionName, newData, sessionData, sessionId, newSessionData;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            baseUrl = _ref.baseUrl, sessionName = _ref.sessionName, newData = (0, _objectWithoutProperties2["default"])(_ref, ["baseUrl", "sessionName"]);

            if (!(!sessionName || !baseUrl)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            sessionData = (0, _getSession["default"])(sessionName);
            sessionId = sessionData.sessionId;

            if (sessionId) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return");

          case 7:
            newSessionData = (0, _ramda.mergeDeepRight)(sessionData, _objectSpread({}, newData));
            (0, _setSession["default"])(sessionName, newSessionData);
            _context.next = 11;
            return fetch("".concat(baseUrl, "/sessions/"), {
              body: JSON.stringify(newSessionData),
              method: 'post'
            }).then(function (res) {
              return res.json();
            }) // eslint-disable-next-line no-console
            ["catch"](function (err) {
              return console.error(err.message);
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateSession(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = updateSession;
exports["default"] = _default;